export default "__VITE_ASSET__DuNimDBh__"